// Per-agency white-label branding. The server (GET /api/v1/branding) does ALL the
// colour maths — hex validation, WCAG luminance, dark/light logo selection — and
// returns final CSS custom-property values as a ready-to-inject `:root{...}` block
// in `cssVars`. The SPA just injects that string, so it never re-implements the
// Python _brand_css_vars logic and cannot drift visually. (Migration plan: "port
// the Python logic server-side and return computed CSS-var values".)

export interface BrandingData {
  agencyName: string;
  primaryColour: string;
  secondaryColour: string;
  logoUrl: string;
  logoStyle: "auto_invert" | "badge" | "variant" | "white_bar" | string;
  logoUrlLight: string;
  logoUrlDark: string;
  isDark: boolean;
  logoFilter: string;
  cssVars: string;
}

/** Inject the server-computed brand variables into a single managed <style>. */
export function applyBranding(b: BrandingData | undefined | null): void {
  if (!b?.cssVars) return;
  let el = document.getElementById("brand-vars") as HTMLStyleElement | null;
  if (!el) {
    el = document.createElement("style");
    el.id = "brand-vars";
    document.head.appendChild(el);
  }
  el.textContent = b.cssVars;
}

/** True when a payload carries a usable server-computed brand block. */
export function hasBranding(data: unknown): data is { branding: BrandingData } {
  const b = (data as { branding?: { cssVars?: unknown } } | null)?.branding;
  return typeof b?.cssVars === "string" && b.cssVars.length > 0;
}
